// import React from "react";
// import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
// import HomePage from "./HomePage";
// import TutorPage from "./TutorPage";
// import StudentPage from "./StudentPage";
// import AdministratorPage from "./AdministratorPage";
// const RouterMain = () => {
//   return (
//     <div>
//       {/* <ScrollToTop/> */}
//       <Routes>
//        <Route path="/" element={<HomePage />} />
//         <Route path="/tutor" element={<TutorPage/>} />
//         <Route path="/student" element={<StudentPage/>} />
//         <Route path="/administrator" element={<AdministratorPage/>} />
//       </Routes>
//     </div>
//   );
// };

// export default RouterMain;

import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import TutorPage from "./TutorPage";
import StudentPage from "./StudentPage";
import AdministratorPage from "./AdministratorPage";
import RootPage from "./RootPage";
import AboutUs from "./AboutUs";
import ScrollToTop from "./ScrollToTop";

const RouterMain = () => {
  return (
    <div>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<RootPage/>} />
        <Route path="/tutor" element={<TutorPage />} />
        <Route path="/student" element={<StudentPage />} />
        <Route path="/administrator" element={<AdministratorPage />} />
        <Route path="/about" element={<AboutUs />} />
        <Route path="/about-us" element={<AboutUs />} />
      </Routes>
    </div>
  );
};

export default RouterMain;
